module.exports = __webpack_public_path__ + "static/media/bg.b91c51ae.png";